import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class MeetingRoomsService {

    getMeetingRooms(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MEETING_ROOMS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putMeetingRooms(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MEETING_ROOMS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getMeetingRoomAmenities(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MEETING_ROOM_AMENITIES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new MeetingRoomsService()